<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.0141 15.2536C26.5041 15.2536 29.3334 12.4359 29.3334 8.96012C29.3334 5.48435 26.5041 2.66669 23.0141 2.66669C19.5241 2.66669 16.6949 5.48435 16.6949 8.96012C16.6949 10.5701 17.4297 11.7409 17.4297 11.7409L9.78778 19.3516C9.44487 19.6931 8.96481 20.581 9.78778 21.4006L10.6695 22.2788C11.0124 22.5715 11.8746 22.9813 12.58 22.2788L13.6087 21.2543C14.6374 22.2788 15.8131 21.6934 16.254 21.1079C16.9887 20.0834 16.107 19.0589 16.107 19.0589L16.4009 18.7662C17.8117 20.1712 19.0462 19.3516 19.4871 18.7662C20.2219 17.7417 19.4871 16.7171 19.4871 16.7171C19.1931 16.1317 18.6053 16.1317 19.3401 15.4L20.2219 14.5218C20.9273 15.1072 22.3773 15.2536 23.0141 15.2536Z"
            stroke="#222222"
            stroke-width="1.6"
            stroke-linejoin="round"
        />
        <path
            d="M29.3333 19.9906C29.2481 23.7161 28.8922 25.892 27.4055 27.3788C25.4509 29.3334 22.3051 29.3334 16.0134 29.3334C9.72165 29.3334 6.57579 29.3334 4.62121 27.3788C2.66663 25.4242 2.66663 22.2783 2.66663 15.9866C2.66663 9.69491 2.66663 6.54905 4.62121 4.59447C6.10795 3.10773 8.28393 2.75187 12.0093 2.66669"
            stroke="#222222"
            stroke-width="1.6"
            stroke-linecap="round"
        />
        <circle
            cx="23"
            cy="8.99998"
            r="2.2"
            stroke="#222222"
            stroke-width="1.6"
        />
    </svg>
</template>

<script>
export default {
    name: "KeyInSquareIcon",
};
</script>
